"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/*
 * Copyright 2023, Polytechnique Montreal and contributors
 *
 * This file is licensed under the MIT License.
 * License text available at https://opensource.org/licenses/MIT
 */
const react_1 = __importStar(require("react"));
const react_redux_1 = require("react-redux");
const react_router_1 = require("react-router");
const surveyHelperNew = __importStar(require("evolution-common/lib/utils/helpers"));
const LoadingPage_1 = __importDefault(require("chaire-lib-frontend/lib/components/pages/LoadingPage"));
const SurveyAdmin_1 = require("../../../actions/SurveyAdmin");
const WithPreferencesHoc_1 = require("../../hoc/WithPreferencesHoc");
const Survey_1 = __importDefault(require("../../pageParts/Survey"));
const react_i18next_1 = require("react-i18next");
const SurveyContext_1 = require("../../../contexts/SurveyContext");
const Survey_2 = require("../../../actions/Survey");
const SurveyCorrection = () => {
    const { t } = (0, react_i18next_1.useTranslation)(['admin', 'survey', 'main']);
    const interview = (0, react_redux_1.useSelector)((state) => state.survey.interview);
    const interviewLoaded = (0, react_redux_1.useSelector)((state) => state.survey.interviewLoaded);
    const dispatch = (0, react_redux_1.useDispatch)();
    const navigate = (0, react_router_1.useNavigate)();
    const { interviewUuid } = (0, react_router_1.useParams)();
    const { sections } = (0, react_1.useContext)(SurveyContext_1.SurveyContext);
    // Use the redux actions for the corrected interview
    const startUpdateInterviewAction = react_1.default.useCallback((data, callback) => dispatch((0, SurveyAdmin_1.startUpdateSurveyCorrectedInterview)(Object.assign(Object.assign({}, data), { gotoFunction: navigate }), callback)), []);
    const startAddGroupedObjectsAction = react_1.default.useCallback((newObjectsCount, insertSequence, path, attributes, callback, returnOnly) => dispatch((0, SurveyAdmin_1.startSurveyCorrectedAddGroupedObjects)(newObjectsCount, insertSequence, path, attributes, callback, returnOnly)), []);
    const startRemoveGroupedObjectsAction = react_1.default.useCallback((paths, callback, returnOnly) => dispatch((0, SurveyAdmin_1.startSurveyCorrectedRemoveGroupedObjects)(paths, callback, returnOnly)), []);
    const startNavigateAction = react_1.default.useCallback((options) => dispatch((0, SurveyAdmin_1.startNavigateCorrectedInterview)(Object.assign(Object.assign({}, options), { gotoFunction: navigate }))), [dispatch]);
    if (interviewUuid === undefined) {
        return (react_1.default.createElement("div", { className: "survey", style: { display: 'block' }, id: "surveyErrorPage" },
            react_1.default.createElement("h2", null, t(['survey:AnErrorOccurred', 'main:AnErrorOccurred'])),
            react_1.default.createElement("p", null, t('admin:MissingUuidSurvey'))));
    }
    // Initialize navigation service before setting the interview in the next useEffect
    react_1.default.useEffect(() => {
        dispatch((0, Survey_2.initNavigationService)(sections));
    }, [sections, dispatch]);
    react_1.default.useEffect(() => {
        // Load the interview when first mounting the component
        dispatch((0, SurveyAdmin_1.startSetSurveyCorrectedInterview)(interviewUuid));
    }, [interviewUuid, dispatch]); // Reload the interview if the uuid changes
    // FIXME See if we can use react Suspense instead of this logic for the loading page (https://react.dev/reference/react/Suspense)
    if (!interviewLoaded || !interview || !interview.sectionLoaded) {
        surveyHelperNew.devLog('%c rendering empty survey', 'background: rgba(0,0,0,0.1);');
        return react_1.default.createElement(LoadingPage_1.default, null);
    }
    return (react_1.default.createElement(Survey_1.default, { startUpdateInterview: startUpdateInterviewAction, startAddGroupedObjects: startAddGroupedObjectsAction, startRemoveGroupedObjects: startRemoveGroupedObjectsAction, startNavigate: startNavigateAction, interview: interview }));
};
exports.default = (0, WithPreferencesHoc_1.withPreferencesHOC)(SurveyCorrection);
//# sourceMappingURL=SurveyCorrection.js.map